import axios from 'api/axios'
import { ClientProfile } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * API call to convert a live client back to trial (DEMO) mode with a trial end date.
 * @param id - client id
 * @param trialEndsAt - Unix timestamp (ms) or ISO date string for trial end
 * @returns Updated ClientProfile
 */
export const convertToTrial = async (
	id: string,
	trialEndsAt: number | string
) => {
	try {
		const { data } = await axios.patch<ClientProfile>(
			`client/trial/convert-to-trial/${id}`,
			{ trialEndsAt }
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default convertToTrial
